import React, { useMemo } from 'react'
import ScrRecommendations from 'src/mentor/components/EmrRelatedComponents/screeningRecommendation/components/ScrRecommendations'

export default function ScreeningRecommendationEmrSection({
  screeningRecommendationEmrSection,
  emrSectionDataList,
  setEmrSectionDataList,
  sectionTitle,
  showRedBorder = false,
}) {
  const emrSectionResponse = screeningRecommendationEmrSection?.emrSectionResponse
  const mainSection = emrSectionResponse?.section
  const screeningRecommendationSectionData = useMemo(() => {
    const sectionCode = mainSection?.defCode
    const emrData = emrSectionDataList?.find(
      (sectionData) => sectionData?.sectionCode === sectionCode,
    )
    return emrData
  }, [mainSection, emrSectionDataList])

  function setScreeningRecommendationSectionData(sectionPrev) {
    setEmrSectionDataList((prevList) => {
      const sectionCode = mainSection?.defCode
      let updatedSectionData
      if (typeof sectionPrev === 'function') {
        let currentSectionData = prevList?.find(
          (sectionData) => sectionData?.sectionCode === sectionCode,
        )
        if (!currentSectionData) {
          currentSectionData = {
            sectionCode: mainSection?.defCode,
            sectionVersionUsed: mainSection?.defVersion,
            subSections: [],
          }
        }

        updatedSectionData = sectionPrev(currentSectionData)
      } else {
        updatedSectionData = {
          sectionCode: mainSection?.defCode,
          sectionVersionUsed: mainSection?.defVersion,
          subSections: [],
          ...sectionPrev,
        }
      }

      const doesSectionAlreadyExist = prevList.some(
        (sectionData) => sectionData?.sectionCode === sectionCode,
      )
      if (doesSectionAlreadyExist) {
        return prevList.map((sectionData) =>
          sectionData?.sectionCode === sectionCode ? updatedSectionData : sectionData,
        )
      } else {
        return [...(prevList || []), updatedSectionData]
      }
    })
  }

  return (
    <div className="d-flex flex-column gap-1">
      <ScrRecommendations
        screeningEmrSectionDef={mainSection}
        screeningRecommendationSectionData={screeningRecommendationSectionData}
        setScreeningRecommendationSectionData={setScreeningRecommendationSectionData}
        sectionTitle={sectionTitle}
        showRedBorder={showRedBorder}
      />
    </div>
  )
}
